import { useTypedParams } from "react-router-typesafe-routes";

import { ClientEmployeeFileUploadsCard } from "@components/Cards";

import { routes } from "@pages/routes";

export const ClientEmployeeFileUploads = () => {
  const { clientId, clientEmployeeId } = useTypedParams(
    routes.portal.clients.client.clientEmployees.clientEmployee,
  );

  return (
    <ClientEmployeeFileUploadsCard
      clientId={clientId}
      employeeId={clientEmployeeId}
    />
  );
};
